export enum EAccountTypes {
  TRIAL = 'TRIAL',
  SUBSCRIBED = 'SUBSCRIBED',
  UNSUBSCRIBED = 'UNSUBSCRIBED',
  TEST = 'TEST',
  UNSET = 'UNSET',
}
